import { useEffect } from 'react';
import { useAppState } from '../state/AppState';
import { getMtgSessionFromQuery } from '../services/sessionService';

/**
 * Custom hook to initialize mtgSession query parameter from URL on app load.
 *
 * This hook should be called once when the app initializes to extract and store
 * the mtgSession parameter from the URL in the application state.
 *
 * @example
 * ```tsx
 * function App() {
 *   useQueryParamsInitialization();
 *   return <div>App content</div>;
 * }
 * ```
 */
export function useQueryParamsInitialization() {
  const { dispatch } = useAppState();

  useEffect(() => {
    // Get mtgSession from URL parameters
    const mtgSession = getMtgSessionFromQuery();
    
    if (mtgSession) {
      dispatch({ type: 'SET_MTG_SESSION', payload: mtgSession });
    }
  }, [dispatch]); // Only run once on mount
} 